import { useEffect } from 'react'
import { DataLayer } from '../../common/analytics/dataLayer'

export const CHECKOUT_TYPES = {
  CART: 'cart',
  CONTAINER: 'container',
  GIFTCARD: 'giftcard'
}

export const useAnalyticsViewCart = (payload) => {
  const dependencyKey = payload?.items.map((item) => item.item_id).join('-')
  useEffect(() => {
    if (!payload) return
    DataLayer.trackCartView(payload)
    // don't include items in dependency array
    // because of referential equality, it's different on every re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependencyKey])
}
